import React, { useState, useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'
import HomeworkInfo from '@/components/organisms/Card/Homework/HomeworkInfo'
import HomeworkScore, { GradingResultSummary } from '@/components/organisms/Card/Homework/HomeworkScore'
import { academyLearningScheduleApi } from 'services/api'

const AcademyLearningGradingDetail = () => {
  const [searchParams] = useSearchParams();
  const scheduleId = searchParams.get('id');
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>(null);
  const [gradingResult, setGradingResult] = useState<GradingResultSummary | null>(null);
  const bulkAiRef = useRef<{ runBulkAiGrading?: () => Promise<void> } | null>(null);
  const [bulkAiLoading, setBulkAiLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      if (!scheduleId) {
        console.error('스케줄 ID가 없습니다.');
        setLoading(false);
        return;
      }

      try {
        console.log('채점 상세 데이터 로드:', scheduleId);
        const response = await academyLearningScheduleApi.gradingDetail(Number(scheduleId));
        
        if (response.success) {
          console.log('채점 상세 데이터:', response.data);
          setData(response.data);
        } else {
          console.error('데이터 로드 실패:', response.message);
        }
      } catch (error) {
        console.error('채점 상세 조회 실패:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [scheduleId]);

  if (loading) {
    return (
      <main className='lg:my-10'>
        <div className='flex justify-center items-center h-64'>
          <p>로딩 중...</p>
        </div>
      </main>
    );
  }

  if (!data) {
    return (
      <main className='lg:my-10'>
        <div className='flex justify-center items-center h-64'>
          <p>데이터를 불러올 수 없습니다.</p>
        </div>
      </main>
    );
  }

  return (
    <main className='lg:my-10'>
      <div className='flex flex-col'>
        <div className='flex justify-between items-center pb-5'>
          <h1 className='heading1'>숙제 채점 상세</h1>
        </div>
      </div>
      <div className='flex flex-col lg:gap-10 lg:flex-row lg:items-start'>
      {/* 숙제 채점표 */}
      <section className='order-2 p-0 lg:order-1 w-full lg:flex-1 lg:min-w-[640px]'>
          <div className='flex-1 w-full *:shadow-none border border-gray-100 rounded-2xl'>
              <HomeworkScore 
                ref={bulkAiRef as any}
                type='grading' 
                platform='academy'
                data={data} 
                onGradingResultChange={setGradingResult}
              />
          </div>
      </section>
      
      <section className='p-5 bg-white card lg:max-w-[500px] order-1 lg:order-2 lg:sticky lg:top-5'>
          <HomeworkInfo 
            type='grading' 
            data={data} 
            gradingResult={gradingResult}
            bulkAiLoading={bulkAiLoading}
            onBulkAiGrading={async () => {
              if (bulkAiLoading) return;
              setBulkAiLoading(true);
              try {
                await bulkAiRef.current?.runBulkAiGrading?.();
              } catch (e) {
                alert('AI 일괄 채점 중 오류가 발생했습니다.');
              } finally {
                setBulkAiLoading(false);
              }
            }}
          />
      </section>

      </div>
    </main>
  )
}

export default AcademyLearningGradingDetail